import * as React from 'react';
import { SVGProps } from 'react';

const IconUploadSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 10v1h10v-1H1zm5.501-1V2.914L8.86 5.28l.707-.707L6 1 2.46 4.538l.707.707L5.5 2.915V9h1z" />
  </svg>
);
export default IconUploadSizeXs;
